import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { isNilOrEmpty } from 'packages/core'
import { MUIDateTimePicker } from 'packages/eid-ui/DateTimePickers'

export interface StartDateTimePickerProps {
    selectedStartDate: any
    setSelectedStartDate: any
    disabled: boolean
    label?: string
}

export const StartDateTimePicker: FC<StartDateTimePickerProps> = ({
    selectedStartDate,
    setSelectedStartDate,
    disabled,
    label = 'StartDateTime',
}) => {
    const { t } = useTranslation()

    return (
        <MUIDateTimePicker
            dateTimeFormat="L LT"
            minDate={moment(new Date()).format()}
            value={selectedStartDate ? moment(selectedStartDate) : null}
            handleChange={(e: any) => {
                if (isNilOrEmpty(e)) {
                    setSelectedStartDate(moment().utc().format())
                } else {
                    const date = moment(e)
                    const dateToSet = date.clone().utc().format()
                    setSelectedStartDate(dateToSet)
                }
            }}
            label={t(label)}
            disabled={disabled}
        />
    )
}
